// Override Turbo's native confirm dialog with a styled modal.
// Uses window.Turbo (set by @hotwired/turbo-rails) to avoid
// importing a separate instance of @hotwired/turbo.
const { Turbo } = window

Turbo.config.forms.confirm = (message, formElement, submitter) => {
  const element = submitter || formElement
  return new Promise((resolve) => {
    const backdrop = document.createElement("div")
    backdrop.className = "fixed inset-0 z-50 flex items-center justify-center bg-black/50 transition-opacity"
    backdrop.setAttribute("aria-modal", "true")
    backdrop.setAttribute("role", "dialog")

    const title = element?.dataset?.confirmTitle || "Confirmation"
    const confirmLabel = element?.dataset?.confirmButton || "Confirmer"
    const cancelLabel = element?.dataset?.cancelButton || "Annuler"

    backdrop.innerHTML = `
      <div class="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-md mx-4 p-6 relative">
        <h3 class="text-lg font-bold mb-2">${escapeHtml(title)}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-300 mb-6">${escapeHtml(message)}</p>
        <div class="flex justify-end gap-2">
          <button type="button" data-action="cancel"
            class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-gray-500">
            ${escapeHtml(cancelLabel)}
          </button>
          <button type="button" data-action="confirm"
            class="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-red-500">
            ${escapeHtml(confirmLabel)}
          </button>
        </div>
      </div>
    `

    const close = (result) => {
      document.removeEventListener("keydown", handleKeydown)
      backdrop.remove()
      resolve(result)
    }

    const handleKeydown = (e) => {
      if (e.key === "Escape") close(false)
    }

    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) close(false)
      if (e.target.dataset.action === "cancel") close(false)
      if (e.target.dataset.action === "confirm") close(true)
    })

    document.addEventListener("keydown", handleKeydown)
    document.body.appendChild(backdrop)

    // Focus the cancel button for accessibility
    backdrop.querySelector('[data-action="cancel"]').focus()
  })
}

function escapeHtml(text) {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}
